module.exports = __webpack_public_path__ + "assets/img/bjimg2.d4373ba8.png";